import { render, staticRenderFns } from "./ModalOrderRestore.vue?vue&type=template&id=20db223b&"
import script from "./ModalOrderRestore.vue?vue&type=script&lang=js&"
export * from "./ModalOrderRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports